import { VehicleExtraOption } from "@/models/vehicle";

export interface VehicleExtraGroup {
  typeId: number;
  typeName: string;
  options: VehicleExtraOption[];
}

/**
 * Groups extras by their type (e.g. Warranty, Cosmetic Repair) so a vehicle can
 * carry one option per type. Deleted, disabled and placeholder rows are dropped.
 * Groups preserve the order in which each type is first seen.
 */
export function groupExtrasByType(
  options: VehicleExtraOption[] | null | undefined
): VehicleExtraGroup[] {
  const groups = new Map<number, VehicleExtraGroup>();
  for (const option of options ?? []) {
    if (option.isDeleted || option.isDisabled || option.isEmptyPlaceholder) continue;
    let group = groups.get(option.vehicleExtraTypeId);
    if (!group) {
      group = {
        typeId: option.vehicleExtraTypeId,
        typeName: option.vehicleExtraTypeName,
        options: [],
      };
      groups.set(option.vehicleExtraTypeId, group);
    }
    group.options.push(option);
  }
  return [...groups.values()];
}
